import en from './en'
import ko from './ko'
import elementEn from 'element-ui/lib/locale/lang/en'
import elementKo from 'element-ui/lib/locale/lang/ko'

const lang = {
  en: {
    ...en,
    ...elementEn,
  },
  ko: {
    ...ko,
    ...elementKo,
  },
}

// videojs 지원 언어 자동 생성을 위해 추가
const langList = Object.keys(lang)

for (const index in langList) {
  let thisLang = require(`video.js/dist/lang/${langList[index]}.json`)

  lang[langList[index]] = Object.assign(lang[langList[index]], { ...thisLang })
}

export default lang
